import Tree from '../Tree/Tree';
import FormSection from '../FormSection/FormSection';
import { buildTeamHierarchy } from '../../../utils/functions';
import { anyTeamHasChildren, getDisabledTeamIds } from '../../../utils/reports';

import './ActiveTeamsTree.scss';

interface IActiveTeamsTreeProps {
  teams?: ITeam[];
  activeTeams?: string[];
  isLocked?: boolean;
  subHeader?: string;
  noDefault?: boolean;
  isSearchable?: boolean;
  showTooltip?: boolean;
  error?: string;
  onSelectedChange: (selectedIds: string[]) => void;
}

const ActiveTeamsTree = ({
  teams,
  activeTeams,
  isLocked = false,
  subHeader = 'Teams',
  noDefault,
  isSearchable = false,
  showTooltip = false,
  error,
  onSelectedChange,
}: IActiveTeamsTreeProps) => {
  const treeData = buildTeamHierarchy({ teams, sorted: true });
  const hasChildren = anyTeamHasChildren(treeData);
  const shouldHideExpandCollapse = !noDefault || !hasChildren;

  const disabledIds = getDisabledTeamIds(treeData);
  const filteredActiveTeams = activeTeams?.filter((id) => !disabledIds.has(id));

  return (
    <FormSection
      className="ActiveTeamsTree"
      subheader={subHeader}
      info="Select which teams appear in your reports."
      tooltip={
        showTooltip
          ? {
              id: 'tooltip-teams',
              icon: 'help',
              placement: 'right',
              text: 'Teams for which you have reporting access',
            }
          : undefined
      }
    >
      <Tree
        binarySelect
        noCascadeDown
        startExpanded
        data={treeData}
        isLocked={isLocked}
        hideExpandCollapse={shouldHideExpandCollapse}
        initialSelections={filteredActiveTeams}
        searchable={isSearchable}
        hasClearAll={noDefault}
        error={error}
        onSelectedChange={onSelectedChange}
      />
    </FormSection>
  );
};

export default ActiveTeamsTree;
